import { render, staticRenderFns } from "./TilesGallery.vue?vue&type=template&id=863b8074&scoped=true&"
import script from "./TilesGallery.vue?vue&type=script&lang=js&"
export * from "./TilesGallery.vue?vue&type=script&lang=js&"
import style0 from "./TilesGallery.vue?vue&type=style&index=0&id=863b8074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863b8074",
  null
  
)

export default component.exports